import Dexie, { Table } from 'dexie';

export interface OfflineInspection {
  id?: number;
  localId: string;
  jobId: string;
  leadId?: string;
  formData: any;
  photos: OfflinePhoto[];
  createdAt: string;
  synced: boolean;
  syncedAt?: string;
}

export interface OfflinePhoto {
  id?: number;
  inspectionId: string;
  localPath: string;
  base64Data?: string;
  timestamp: string;
  latitude?: number;
  longitude?: number;
  synced: boolean;
}

export interface OfflineEstimate {
  id?: number;
  localId: string;
  jobId?: string;
  leadId?: string;
  estimateData: any;
  createdAt: string;
  synced: boolean;
  pdfUrl?: string;
}

export class OfflineDatabase extends Dexie {
  inspections!: Table<OfflineInspection, number>;
  photos!: Table<OfflinePhoto, number>;
  estimates!: Table<OfflineEstimate, number>;

  constructor() {
    super('RoofGeniusOffline');
    
    this.version(1).stores({
      inspections: '++id, localId, jobId, leadId, synced, createdAt',
      photos: '++id, inspectionId, synced, timestamp',
      estimates: '++id, localId, jobId, leadId, synced, createdAt'
    });
  }
}

export const offlineDB = new OfflineDatabase();

// Utility functions
export async function getPendingInspections() {
  return await offlineDB.inspections.where('synced').equals(0).toArray();
}

export async function getPendingPhotos() {
  return await offlineDB.photos.where('synced').equals(0).toArray();
}

export async function getPendingEstimates() {
  return await offlineDB.estimates.where('synced').equals(0).toArray();
}

export async function getTotalPendingCount() {
  const inspections = await getPendingInspections();
  const photos = await getPendingPhotos();
  const estimates = await getPendingEstimates();
  return inspections.length + photos.length + estimates.length;
}
